'use strict'

import React from 'react';

export default class StatusIndicator extends React.Component {
  render() {
    switch (this.props.status) {
      case "green":
        return <img style={{verticalAlign:"bottom"}} src="/images/greenlight.png"/>;
        break;
      case "yellow":
        return <img style={{verticalAlign:"bottom"}} src="/images/yellowlight.png"/>;
        break;
      case "red":
        return <img style={{verticalAlign:"bottom"}} src="/images/redlight.png"/>;
        break;
      default:
        return <span/>;
    }
  }
}



// WEBPACK FOOTER //
// ./views/components/StatusIndicator.jsx